<script>
    import Country from "../SharedComponents/Country.svelte";
    import { push } from "svelte-spa-router";
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";
    import { getContext, tick } from "svelte";
    import { fade } from "svelte/transition";
    import * as SharedComponents from "../SharedComponents/index.js";
    import IconDelete from "../Vectors/delete.svelte";
    import IconCopy from "../Vectors/copy.svelte";
    import IconDownload from "../Vectors/download.svelte";
    import IconPlus from "../Vectors/plus.svelte";
    import IconEdit from "../Vectors/edit.svelte";
    import Confirm from "../SharedComponents/Confirm.svelte";
    import Prompt from "../SharedComponents/Prompt.svelte";
    import FactorySelector from "../SharedComponents/FactorySelector.svelte";
    import Date from "../SharedComponents/Date.svelte";

    const { open } = getContext("modal");
    const { snackbar } = getContext("app");
    let searchFilter = "";
    let loading = false;
    let counter = 0;
    let filteredFactories = [];
    async function findFactories(searchFilter, copycounter) {
        loading = true;
        var ret = await factoryStore.findFactories(searchFilter, 1000000);
        filteredFactories = ret.sort((a, b) => {
            return a.lastSettingChangeDate < b.lastSettingChangeDate ? 1 : -1;
        });
        counter++;
        await tick();
        loading = false;
    }
    $: debounceFindFactories(searchFilter, $factoryStore.lastSyncDate);

    let firstTimeAround = true;
    let timer = null;
    function debounceFindFactories(searchFilter) {
        if (firstTimeAround) {
            firstTimeAround = false;
            findFactories(searchFilter);
            return;
        }
        clearTimeout(timer);
        timer = setTimeout(async () => {
            findFactories(searchFilter);
        }, 500); /// this is the debounce pattern
    }

    $: sortedFactories = (counter && filteredFactories) || [];
    // (counter &&
    //     filteredFactories &&
    //     filteredFactories.sort((f, g) => (f.name > g.name ? 1 : -1))) ||
    // [];
    function editFactory(factory) {
        push("#/calculator/factorysettings/" + factory.uuid);
    }

    async function downloadFactory(factorySettings) {
        await factoryStore.downloadFactory(factorySettings.uuid);
    }

    async function copyFactorySettings(factorySettings) {
        open(Prompt, {
            confirmAction: async (name) => {
                var newId = await factoryStore.copyFactorySettings(
                    factorySettings.uuid,
                    name
                );
                findFactories(searchFilter);
                snackbar("info", "factory settings copied");
            },
            inputVal:
                factorySettings.name +
                " (" +
                $langTextStore.getText("general-label-copy") +
                " )",
            actionButtonTextOverrideLangKey: "general-label-copy",
            cancelButtonTextOverrideLangKey: "general-label-cancel",
            titleLangKey: "general-copy-factory-setting-name",
            contentLangKey: "general-enter-name-for-new-version",
        });
    }
    var x = $langTextStore.getText("general-label-copy");

    function openFactorySettings(factorySettingsId) {
        push("/calculator/factorysettings/" + factorySettingsId, {
            returnUrl: "/dashboard/factories",
        });
    }

    async function createProductCalculation(factorySettingsId) {
        push("/createproduct/" + factorySettingsId);
    }
    async function checkCreateFactory() {
        var hasFactories = await factoryStore.hasFactories();
        if (!hasFactories) {
            push("/createfactory");
            return;
        }
    }
    checkCreateFactory();

    async function deleteFactorySetting(setting) {
        open(Confirm, {
            confirmAction: async () => {
                await factoryStore.deleteFactorySetting(setting);
                findFactories(searchFilter);
            },
            actionButtonTextOverrideLangKey: "general-label-delete-now",
            cancelButtonTextOverrideLangKey: "general-label-cancel",
            titleLangKey: "general-are-you-sure-delete-factory-setting-title",
            contentLangKey:
                "general-are-you-sure-delete-factory-setting-content",
        });
    }

    let fileInputControl;
    let uploadBusy = false;
    let files = [];
    let uploadToFactoryId;
    async function uploadFile() {
        uploadBusy = true;
        let thefile = files[0];
        var fr = new FileReader();
        fr.onload = function () {
            alert(fr.result);
            var factorySettingUploaded = JSON.parse(fr.result);
            factorySettingUploaded.factoryId = uploadToFactoryId;
            factorySettingUploaded.uuid = null;
            factorySettingUploaded.name =
                factorySettingUploaded.name + " uploaded copy ";
            factoryStore.saveFactoryOrProductSettings(factorySettingUploaded);
            alert("its uploaded");
        };

        fr.readAsText(thefile);

        fileInputControl.value = "";
        uploadBusy = false;
    }
</script>

<div class="row g-0 px-5">
    <div class="col-9 col-md-7 mb-3">
        <h2 class="intro">
            {@html $langTextStore.getText(
                "general-text-create-or-edit-factory-settings"
            )}
        </h2>
        {@html $langTextStore.getText(
            "general-text-create-or-edit-factory-settings-intro"
        )}
    </div>
    <div class="col-6 list-head">
        <button
            class="btn btn-primary mt-5 mb-4 px-4 w-auto float-start"
            on:click={() => push("/createfactory/")}
            >{$langTextStore.getText("general-labels-add-factory")}
        </button>
    </div>
    <div class="col-6 list-head text-right">
        <input
            type="text"
            class="search mt-5 mb-4"
            bind:value={searchFilter}
            placeholder={$langTextStore.getText("general-labels-search")}
        />
    </div>
    {#if !loading}
        <div class="col-12 list-main" in:fade>
            {#each sortedFactories as factory}
                <div class="list-main__item row g-0 ">
                    <div class="col-12 col-md-6 font-weight-bold text-gray-5">
                        {factory.name} (<Country
                            countryId={factory.countryId}
                        /> )
                    </div>
                    <div
                        class="d-none d-md-flex col-3 font-weight-bold text-gray-5"
                    >
                        {$langTextStore.getText(
                            "general-labels-date-last-edit"
                        )}
                    </div>

                    <div class="col-12 list">
                        {#each factory.factorySettings as factorySetting}
                            <div
                                class="row gx-0 py-0 row-with-default-button"
                                on:click={openFactorySettings(
                                    factorySetting.uuid
                                )}
                            >
                                <div class="col-12 py-1 col-md-6 px-0">
                                    {factorySetting.name} (
                                    {$langTextStore.getText(
                                        "general-labels-calculator-version"
                                    )}
                                    {factorySetting.calculatorVersionNumber})
                                </div>
                                <div class="col-8  py-1 col-md-3 col-lg-4 px-0">
                                    <SharedComponents.Date
                                        date={factorySetting.changeDate}
                                    />
                                </div>

                                <div
                                    class="col-4  py-1 col-md-3  col-lg-2 text-right px-0 cancel-default-focus"
                                    on:click|preventDefault|stopPropagation
                                >
                                    <IconDelete
                                        on:click={deleteFactorySetting(
                                            factorySetting
                                        )}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-delete"
                                        )}
                                    />
                                    <IconCopy
                                        on:click={copyFactorySettings(
                                            factorySetting
                                        )}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-copy"
                                        )}
                                    />
                                    <IconDownload
                                        on:click={downloadFactory(
                                            factorySetting
                                        )}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-download"
                                        )}
                                    />
                                    <IconPlus
                                        on:click={createProductCalculation(
                                            factorySetting.uuid
                                        )}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-make-product"
                                        )}
                                    />
                                    <IconEdit
                                        on:click={openFactorySettings(
                                            factorySetting.uuid
                                        )}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-edit"
                                        )}
                                    />
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            {/each}
            <hr />
        </div>
    {/if}

    <!-- <div class="mb-3" style=" width: 400px; height: 30px; overflow: hidden;">
        <div
            style="width: 3600px; height: 40px; position: relative;
          top: 10px; left: 0px;text-decoration:underline;cursor:pointer"
        >
            {#if files && files.length > 0}{files[0].name}{:else}Choose{/if}
        </div>
        <input
            type="file"
            id="upload_input"
            bind:files
            bind:this={fileInputControl}
            name="upload"
            style="font-size: 50px; width: 120px; opacity: 0; filter:alpha(opacity=0);
          position: relative; top: -40px;; left: -20px"
            title=""
        />
    </div>
    Choose Factory to upload these settings to make sure country is correct
    <FactorySelector bind:factoryId={uploadToFactoryId} />
    <button class="btn btn-secondary" on:click={uploadFile}
        >upload factory setting</button
    > -->

    <div class="col-12 col-md-7 mt-3 mb-5 text-small">
        {$langTextStore.getText("general-footer-text")}
    </div>
    <div class="mb-5">
        <a href="privacy.pdf" style="font-size:.8rem;">
            {$langTextStore.getText("general-privacy-statement")}</a
        >
        -
        <a href="terms.pdf" style="font-size:.8rem;">
            {$langTextStore.getText("general-terms")}</a
        >
    </div>
</div>

<style>
    :global(body) {
        overflow-y: auto;
    }
</style>
